import React, {Fragment,} from 'react';
import { useAuth } from '../../Context/Context';
import { WavyLink } from "react-wavy-transitions";

import img1 from "../../Images/Servicios/DiesnioDigital/1.png"
import img12 from "../../Images/Servicios/DiesnioDigital/2.png"

import Portafolio from '../../Components/Portafolio';
import Efectos from '../../Components/Efectos';
import Contacto from '../../Components/Contacto';
import Disenio from '../../Components/Galerias/Disenio';


const DisenioDigital = () => {
    const { direction, cambio } = useAuth();

    return(
        <Fragment>
            <div>
                <div className='fondo_servicio_6'>
                    <div>
                        <p className='sub_titulo_nv_4' style={{color:"#ffffff"}}>
                            <span className='titulo_nv_2' style={{color:"#B5FCFD"}}>
                                Diseño digital <br/>
                            </span>
                            Tu identidad corporativa 
                        </p>
                        <div className='cont_5'>
                            <p>
                                Sabemos que la primera impresión es lo que vale, por lo tanto 
                                tenemos para ti las mejores opciones de mostrar tu marca a tus 
                                clientes con simples detalles que hacen una gran diferencia.
                            </p>
                        </div>
                    </div>
                    <div>
                        {window.screen.width <= 550 ? (
                            <Efectos activado={true}>
                                <img class="scroll-element js-scroll fade-in-bottom" src={img12} alt="" style={{width:"100%"}}/>
                            </Efectos>
                        ) : (
                            <Efectos activado={true}>
                                <img class="scroll-element js-scroll fade-in-bottom" src={img1} alt="" style={{width:"100%", maxWidth:"1485px"}}/>
                            </Efectos>
                        )}
                    </div>
                </div>

                <div className='container'>
                    <Disenio />
                </div>

                <div style={{display:"flex", justifyContent:"center", margin:"40px 0"}}>
                    <WavyLink direction={direction ? "up" : "down"} to="/contacto" color={direction ? "#BF1F60" : "#2A79B0"}>
                        <p class="btn_1" onClick={cambio} style={{margin:"0px", color:"#fff"}}>
                            Cotiza tu proyecto
                        </p>
                    </WavyLink>
                    {/* <div className='btn_1'>
                        <a href="/contacto" style={{color:"#fff"}}>
                            <p>
                                Cotiza tu proyecto
                            </p>
                        </a>
                    </div> */}
                </div>

                <Portafolio />
                <Contacto />
                
            </div>
        </Fragment>
    )
}

export default DisenioDigital;